(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-main-collection, .oddit-section-collection-tabs';
  var DEBOUNCE_MS = 300;
  var CACHE_LIMIT = 20;

  function debounce(fn, ms) {
    var t = null;
    function debounced() {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        t = null;
        fn.apply(null, args);
      }, ms);
    }
    debounced.cancel = function () { clearTimeout(t); t = null; };
    debounced.flush = function () {
      if (t === null) { fn.apply(null, arguments); return; }
      clearTimeout(t); t = null;
      fn.apply(null, arguments);
    };
    return debounced;
  }

  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/(["\\])/g, '\\$1');
  }

  function bindSlider(scopeSection, onChange) {
    var range = scopeSection.querySelector('.oddit-section-main-collection__price-range');
    if (!range || range.dataset.bound === 'true') return;
    range.dataset.bound = 'true';

    var handles = Array.prototype.slice.call(
      range.querySelectorAll('.oddit-section-main-collection__price-handle')
    );
    if (handles.length < 2) return;
    var fill = range.querySelector('.oddit-section-main-collection__price-fill');
    var inputs = Array.prototype.slice.call(
      scopeSection.querySelectorAll('.oddit-section-main-collection__price-input-value')
    );
    var minInput = inputs[0];
    var maxInput = inputs[1];

    var rangeMin = parseFloat(range.dataset.min);
    if (isNaN(rangeMin)) rangeMin = 0;
    var rangeMax = parseFloat(range.dataset.max);
    if (isNaN(rangeMax)) {
      rangeMax = maxInput ? parseFloat(maxInput.value) || 100 : 100;
    }
    var span = rangeMax - rangeMin;

    function valueToPct(val) {
      if (span <= 0) return 0;
      var pct = ((val - rangeMin) / span) * 100;
      return Math.max(0, Math.min(100, pct));
    }
    function pctToValue(pct) {
      return Math.round(rangeMin + (pct / 100) * span);
    }
    function getPct(h) { return parseFloat(h.style.left) || 0; }

    if (minInput) {
      var minVal = parseFloat(minInput.value);
      handles[0].style.left = valueToPct(isNaN(minVal) ? rangeMin : minVal) + '%';
    }
    if (maxInput) {
      var maxVal = parseFloat(maxInput.value);
      handles[1].style.left = valueToPct(isNaN(maxVal) ? rangeMax : maxVal) + '%';
    }
    updateFill();

    function updateFill() {
      if (!fill) return;
      var positions = handles.map(getPct).sort(function (a, b) { return a - b; });
      fill.style.left = positions[0] + '%';
      fill.style.right = (100 - positions[positions.length - 1]) + '%';
    }

    function syncInputs() {
      var positions = handles.map(getPct).sort(function (a, b) { return a - b; });
      if (minInput) minInput.value = pctToValue(positions[0]);
      if (maxInput) maxInput.value = pctToValue(positions[positions.length - 1]);
    }

    var activeHandle = null;
    var activePointerId = null;

    function pctFromClientX(clientX) {
      var rect = range.getBoundingClientRect();
      if (rect.width === 0) return 0;
      var pct = ((clientX - rect.left) / rect.width) * 100;
      return Math.max(0, Math.min(100, pct));
    }

    function onPointerMove(e) {
      if (!activeHandle) return;
      var pct = pctFromClientX(e.clientX);
      var lo = 0;
      var hi = 100;
      var activePct = getPct(activeHandle);
      handles.forEach(function (h) {
        if (h === activeHandle) return;
        var hPct = getPct(h);
        if (hPct <= activePct) { if (hPct > lo) lo = hPct; }
        else { if (hPct < hi) hi = hPct; }
      });
      pct = Math.max(lo, Math.min(hi, pct));
      activeHandle.style.left = pct + '%';
      updateFill();
      syncInputs();
    }

    function onPointerUp() {
      if (activeHandle && activePointerId !== null) {
        try { activeHandle.releasePointerCapture(activePointerId); } catch (_) {}
      }
      activeHandle = null;
      activePointerId = null;
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('pointercancel', onPointerUp);
      if (onChange) onChange();
    }

    handles.forEach(function (handle) {
      handle.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        activeHandle = handle;
        activePointerId = e.pointerId;
        try { handle.setPointerCapture(activePointerId); } catch (_) {}
        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
        document.addEventListener('pointercancel', onPointerUp);
      });
    });
  }

  function initSection(section) {
    if (section.dataset.odditInit === 'true') return;
    section.dataset.odditInit = 'true';

    var collectionUrl = section.dataset.collectionUrl;
    var sectionId = section.dataset.sectionId;
    var form = section.querySelector('form.oddit-section-main-collection__filters');
    var ajaxEnabled = !!(
      collectionUrl &&
      sectionId &&
      window.fetch &&
      window.URLSearchParams &&
      window.AbortController &&
      window.DOMParser
    );

    if (form) {
      form.addEventListener('click', function (e) {
        var toggle = e.target.closest('.oddit-section-main-collection__filter-toggle');
        if (!toggle) return;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    }

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('.oddit-section-main-collection__variant-thumb');
      if (!thumb) return;
      var group = thumb.closest('.oddit-section-main-collection__variant-thumbs');
      if (!group) return;
      e.preventDefault();
      e.stopPropagation();
      group.querySelectorAll('.oddit-section-main-collection__variant-thumb--selected').forEach(function (t) {
        t.classList.remove('oddit-section-main-collection__variant-thumb--selected');
      });
      thumb.classList.add('oddit-section-main-collection__variant-thumb--selected');

      var card = thumb.closest('.oddit-section-main-collection__product');
      if (!card) return;

      var img = card.querySelector('.oddit-section-main-collection__product-image');
      if (img) {
        if (!img.hasAttribute('data-default-src')) {
          img.setAttribute('data-default-src', img.getAttribute('src') || '');
          img.setAttribute('data-default-srcset', img.getAttribute('srcset') || '');
        }
        var swatchImage = thumb.getAttribute('data-swatch-image');
        var swatchSrcset = thumb.getAttribute('data-swatch-srcset');
        if (swatchImage) {
          img.src = swatchImage;
          if (swatchSrcset) img.srcset = swatchSrcset;
          else img.removeAttribute('srcset');
        } else {
          var defaultSrc = img.getAttribute('data-default-src');
          var defaultSrcset = img.getAttribute('data-default-srcset');
          if (defaultSrc) img.src = defaultSrc;
          if (defaultSrcset) img.srcset = defaultSrcset;
          else img.removeAttribute('srcset');
        }
      }

      var slideIndex = thumb.getAttribute('data-swatch-slide-index');
      var bg = card.querySelector('[data-gallery]');
      if (bg) setGalleryIndex(bg, slideIndex !== null ? parseInt(slideIndex, 10) : 0);
    });

    function hydrateGallery(bg) {
      if (bg.getAttribute('data-gallery-hydrated') === 'true') return;
      bg.setAttribute('data-gallery-hydrated', 'true');
      var json = bg.getAttribute('data-gallery-images');
      if (!json) return;
      var images;
      try { images = JSON.parse(json); } catch (err) { return; }
      if (!Array.isArray(images) || images.length === 0) return;
      var sizes = bg.getAttribute('data-gallery-sizes') || '';
      var existingByIndex = {};
      var existingSlides = bg.querySelectorAll('[data-slide-index]');
      for (var k = 0; k < existingSlides.length; k++) {
        var ix = parseInt(existingSlides[k].getAttribute('data-slide-index'), 10);
        if (!isNaN(ix)) existingByIndex[ix] = true;
      }
      var frag = document.createDocumentFragment();
      for (var i = 0; i < images.length; i++) {
        if (existingByIndex[i]) continue;
        var slide = document.createElement('div');
        slide.className = 'oddit-section-main-collection__hover-slide';
        slide.setAttribute('data-slide-index', String(i));
        var imgEl = document.createElement('img');
        imgEl.className = 'oddit-section-main-collection__product-hover-image';
        imgEl.alt = '';
        imgEl.loading = 'lazy';
        imgEl.setAttribute('fetchpriority', 'low');
        if (sizes) imgEl.sizes = sizes;
        if (images[i].srcset) imgEl.srcset = images[i].srcset;
        imgEl.src = images[i].src;
        slide.appendChild(imgEl);
        frag.appendChild(slide);
      }
      bg.appendChild(frag);
    }

    function setGalleryIndex(bg, rawIndex) {
      hydrateGallery(bg);
      var count = parseInt(bg.getAttribute('data-gallery-count'), 10);
      if (!count || count < 1) return;
      var idx = ((rawIndex % count) + count) % count;
      bg.setAttribute('data-gallery-index', String(idx));
      var slides = bg.querySelectorAll('[data-slide-index]');
      for (var i = 0; i < slides.length; i++) {
        var sIdx = parseInt(slides[i].getAttribute('data-slide-index'), 10);
        slides[i].classList.toggle('oddit-section-main-collection__hover-slide--active', sIdx === idx);
      }
      var card = bg.closest('.oddit-section-main-collection__product');
      if (card) {
        var dots = card.querySelectorAll('[data-gallery-dot]');
        for (var j = 0; j < dots.length; j++) {
          dots[j].classList.toggle('oddit-section-main-collection__dot--active', j === idx);
        }
        var activeDot = dots[idx];
        if (activeDot) {
          var dotsContainer = activeDot.parentElement;
          if (dotsContainer && dotsContainer.scrollWidth > dotsContainer.clientWidth) {
            var perDot = 9.6 + 6;
            var target = activeDot.offsetLeft - (dotsContainer.clientWidth - activeDot.offsetWidth) / 2;
            target = Math.round(target / perDot) * perDot;
            var maxScroll = dotsContainer.scrollWidth - dotsContainer.clientWidth;
            if (target < 0) target = 0;
            if (target > maxScroll) target = maxScroll;
            dotsContainer.scrollTo({ left: target, behavior: 'smooth' });
          }
        }
      }
    }

    section.addEventListener('click', function (e) {
      if (e.target.closest('.gw-add-to-wishlist-product-card-placeholder')) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    section.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-gallery-prev], [data-gallery-next]');
      if (!nav) return;
      e.preventDefault();
      e.stopPropagation();
      var card = nav.closest('.oddit-section-main-collection__product');
      if (!card) return;
      var bg = card.querySelector('[data-gallery]');
      if (!bg) return;
      var current = parseInt(bg.getAttribute('data-gallery-index'), 10) || 0;
      var delta = nav.hasAttribute('data-gallery-prev') ? -1 : 1;
      setGalleryIndex(bg, current + delta);
    });

    var galleryHoverEnabled = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    if (galleryHoverEnabled) {
      section.addEventListener('mouseover', function (e) {
        var card = e.target.closest('.oddit-section-main-collection__product');
        if (!card) return;
        if (e.relatedTarget && card.contains(e.relatedTarget)) return;
        var bg = card.querySelector('[data-gallery]');
        if (!bg) return;
        var current = parseInt(bg.getAttribute('data-gallery-index'), 10) || 0;
        if (current === 0) setGalleryIndex(bg, 1);
      });

      section.addEventListener('mouseout', function (e) {
        var card = e.target.closest('.oddit-section-main-collection__product');
        if (!card) return;
        if (e.relatedTarget && card.contains(e.relatedTarget)) return;
        var bg = card.querySelector('[data-gallery]');
        if (!bg) return;
        setGalleryIndex(bg, 0);
      });
    }

    // Mobile native horizontal scroll: hydrate every card's gallery up
    // front so all slides exist as flex items, then listen to scroll on
    // each hover-bg to update the active dot.
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      section.querySelectorAll('[data-gallery]').forEach(function (bg) {
        hydrateGallery(bg);
        var card = bg.closest('.oddit-section-main-collection__product');
        if (!card) return;

        function syncFromScroll() {
          var w = bg.clientWidth;
          if (w <= 0) return;
          var idx = Math.round(bg.scrollLeft / w);
          var count = parseInt(bg.getAttribute('data-gallery-count'), 10) || 1;
          if (idx < 0) idx = 0;
          if (idx >= count) idx = count - 1;
          if (parseInt(bg.getAttribute('data-gallery-index'), 10) === idx) return;
          bg.setAttribute('data-gallery-index', String(idx));
          var dots = card.querySelectorAll('[data-gallery-dot]');
          for (var i = 0; i < dots.length; i++) {
            dots[i].classList.toggle('oddit-section-main-collection__dot--active', i === idx);
          }
          var activeDot = dots[idx];
          if (activeDot) {
            var dotsContainer = activeDot.parentElement;
            if (dotsContainer && dotsContainer.scrollWidth > dotsContainer.clientWidth) {
              var perDot = 9.6 + 6;
              var target = activeDot.offsetLeft - (dotsContainer.clientWidth - activeDot.offsetWidth) / 2;
              target = Math.round(target / perDot) * perDot;
              var maxScroll = dotsContainer.scrollWidth - dotsContainer.clientWidth;
              if (target < 0) target = 0;
              if (target > maxScroll) target = maxScroll;
              dotsContainer.scrollTo({ left: target, behavior: 'smooth' });
            }
          }
        }

        bg.addEventListener('scroll', syncFromScroll, { passive: true });
      });
    }

    if (!ajaxEnabled) {
      bindSlider(section, function () {});
      return;
    }

    var cache = new Map();
    var abortCtrl = null;
    var lastFetchedKey = new URLSearchParams(window.location.search).toString();

    function buildParams() {
      if (!form) return new URLSearchParams();
      var fd = new FormData(form);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) {
        var val = String(v).trim();
        if (val !== '') params.append(k, val);
      });
      return params;
    }

    function applyHtml(html, opts) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newFilters = doc.querySelector('[data-filters-target]');
      var newResults = doc.querySelector('[data-results-target]');
      var curFilters = section.querySelector('[data-filters-target]');
      var curResults = section.querySelector('[data-results-target]');

      if (newFilters && curFilters) curFilters.innerHTML = newFilters.innerHTML;
      if (newResults && curResults) curResults.innerHTML = newResults.innerHTML;

      bindSlider(section, function () { debounced({}); });

      if (opts.focusInputName != null && opts.focusInputValue != null) {
        var sel = 'input[name="' + cssEscape(opts.focusInputName) +
          '"][value="' + cssEscape(opts.focusInputValue) + '"]';
        var focused = section.querySelector(sel);
        if (focused) {
          try { focused.focus({ preventScroll: true }); }
          catch (_) { focused.focus(); }
        }
      }

      if (opts.scrollResults) {
        var main = section.querySelector('.oddit-section-main-collection__main');
        if (main) {
          var top = main.getBoundingClientRect().top + window.scrollY - 16;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    }

    function applyParams(params, opts) {
      opts = opts || {};
      var key = params.toString();
      if (key === lastFetchedKey && !opts.force) return;

      var browserUrl = collectionUrl + (key ? '?' + key : '');
      var fetchUrl = browserUrl + (key ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

      if (opts.pushState !== false) {
        history.pushState({ __odditMc: sectionId }, '', browserUrl);
        /* TL-136: tell the collection-header badge (and anyone else
           tracking active filter count) that the URL changed so they
           can re-read filter.* params from window.location.search. */
        try {
          document.dispatchEvent(new CustomEvent('oddit:collection-filters-changed'));
        } catch (_) {
          var evt = document.createEvent('Event');
          evt.initEvent('oddit:collection-filters-changed', true, false);
          document.dispatchEvent(evt);
        }
      }

      var results = section.querySelector('[data-results-target]');
      if (results) results.classList.add('is-loading');

      if (cache.has(key)) {
        applyHtml(cache.get(key), opts);
        lastFetchedKey = key;
        if (results) results.classList.remove('is-loading');
        return;
      }

      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      var ctrl = abortCtrl;

      fetch(fetchUrl, { signal: ctrl.signal })
        .then(function (resp) {
          if (!resp.ok) throw new Error('HTTP ' + resp.status);
          return resp.text();
        })
        .then(function (html) {
          if (cache.size >= CACHE_LIMIT) {
            var firstKey = cache.keys().next().value;
            cache.delete(firstKey);
          }
          cache.set(key, html);
          applyHtml(html, opts);
          lastFetchedKey = key;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          console.error('[oddit-main-collection] fetch failed', err);
        })
        .finally(function () {
          if (results) results.classList.remove('is-loading');
          if (abortCtrl === ctrl) abortCtrl = null;
        });
    }

    var debounced = debounce(function (opts) {
      applyParams(buildParams(), opts || {});
    }, DEBOUNCE_MS);

    if (form) {
      form.addEventListener('change', function (e) {
        var target = e.target;
        if (!target || target.tagName !== 'INPUT') return;
        if (target.classList.contains('oddit-section-main-collection__price-input-value')) return;
        debounced({ focusInputName: target.name, focusInputValue: target.value });
      });

      form.addEventListener('blur', function (e) {
        var t = e.target;
        if (t && t.classList && t.classList.contains('oddit-section-main-collection__price-input-value')) {
          debounced.flush({});
        }
      }, true);

      form.addEventListener('keydown', function (e) {
        var t = e.target;
        if (e.key === 'Enter' && t && t.classList && t.classList.contains('oddit-section-main-collection__price-input-value')) {
          e.preventDefault();
          debounced.flush({});
        }
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        debounced.flush({});
      });

      form.addEventListener('click', function (e) {
        var clearBtn = e.target.closest('[data-clear-filters]');
        if (!clearBtn) return;
        e.preventDefault();
        debounced.cancel();
        applyParams(new URLSearchParams(), { pushState: true });
      });
    }

    section.addEventListener('click', function (e) {
      var pageLink = e.target.closest('a.oddit-section-main-collection__page');
      if (!pageLink) return;
      e.preventDefault();
      var url = new URL(pageLink.href, window.location.origin);
      var params = new URLSearchParams(url.search);
      debounced.cancel();
      applyParams(params, { pushState: true, scrollResults: true });
    });

    bindSlider(section, function () { debounced({}); });

    window.addEventListener('popstate', function () {
      var params = new URLSearchParams(window.location.search);
      applyParams(params, { pushState: false });
    });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector(SECTION_SELECTOR);
    if (sec) {
      delete sec.dataset.odditInit;
      initSection(sec);
    }
  });
})();
